import styled from "styled-components";

import { COLORS, THEME } from "../../styles/constants.style";
import { tableHeader, body1Regular } from "../typography/MuiTypography.style";

export const SidebarAccordionWrapper = styled.div`
  .Mui-expanded {
    .MuiAccordionSummary-root {
      color: ${COLORS.cirrus_black7};
    }
  }

  .MuiAccordionSummary-root {
    padding: 0 16px 0 0;
  }

  .side-bar {
    &__accordion {
      background: ${COLORS.cirrus_white};
      color: ${COLORS.cirrus_black7};
      ${tableHeader};
      height: 56px;
      padding: 0 16px;
      margin: 4px 0;
      display: flex;

      &:hover {
        text-decoration: none;
        background-color: rgba(0, 0, 0, 0.04);
      }

      .MuiAccordionSummary-content {
        display: flex;
        align-items: center;
      }

      .Mui-expanded {
        min-height: 56px;
        align-items: center;

        span {
          font-weight: ${THEME.fontWeights["bold"]};
        }

        .item-indicator {
          background-color: ${COLORS.cirrus_black7};
        }
      }

      .MuiAccordionSummary-expandIconWrapper.Mui-expanded svg {
        color: ${COLORS.cirrus_black7};
      }
    }
  }

  .blue-bg {
    background: ${COLORS.primary_light_blue2};
  }

  .single-item {
    background: ${COLORS.cirrus_white};
    min-height: 56px;
    padding: 16px;
  }

  .single-item-text {
    margin-left: 0px;
  }

  .item-wrapper {
    padding-left: 16px;
  }

  .item {
    display: flex;
    flex-direction: row;
    align-items: center;
    background: ${COLORS.cirrus_white};
    padding-left: 24px;
    min-height: 50px;

    &.selected {
      background: ${COLORS.primary_light_blue2};
      border-radius: 8px;
    }
  }

  .MuiAccordion-heading {
    .MuiAccordionSummary-content {
      margin: 0;
    }
  }

  .item-indicator {
    width: 3px;
    height: 18px;
    background-color: ${COLORS.cirrus_black4};
    margin-right: 12px;

    &.selected {
      background-color: ${COLORS.primary_light_blue};
    }
  }

  .item-text {
    color: ${COLORS.cirrus_black7};

    &.selected {
      color: ${COLORS.primary_light_blue};
      ${body1Regular}
      font-weight: ${THEME.fontWeights["bold"]};
    }
  }

  .icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 24px;
    width: 24px;
    margin-right: 8px;
  }

  .icon {
    object-fit: contain;
  }

  .nested-accordion {
    .MuiAccordionSummary-root {
      padding: 0 16px 0 24px;
      margin: 0;
      height: 50px;
    }

    .MuiAccordionSummary-root.selected {
      background: transparent;
      border-radius: 0px;
      .item-text {
        color: ${COLORS.cirrus_black7};
        font-weight: ${THEME.fontWeights["bold"]};
      }
      .item-indicator {
        background-color: ${COLORS.cirrus_black7};
      }
    }

    .nested-items {
      padding: 0 0 0 16px;

      .item-indicator {
        height: 12px;
        width: 12px;
        border-radius: 50%;
        border: 2px solid ${COLORS.cirrus_black4};
        background-color: transparent;
        flex-shrink: 0;

        &.selected {
          border-color: ${COLORS.primary_light_blue};
        }
      }

      .item.nested {
        padding-left: 24px;
      }
    }
  }

  .nested-accordion::before {
    display: none;
  }
`;
